export default {
	"dynamicReport": {
		"showWay": "โหมดการแสดงผล",
		"beforeShow": "แสดงเฉพาะด้านหน้า",
		"countData": "ข้อมูลสินค้า",
		"dynamicreportTips": "นับเฉพาะข้อมูลของแผนกของผู้ใช้เท่านั้น",
		"dynamicreportWay": "วิธีการสรุป",
		"dynamicreportKeyOtherName": "ชื่อย่อช่องกรอกข้อมูลสถิติ",
		"enableRoles": "ดูบทบาทหน้าที่",
		"enableUser": "ดูผู้ใช้",
		"optionClickHandleTips": "กรุณาเลือกดูบทบาทหน้าที่",
		"selectedValueOfTransferTips": "กรุณาเลือกบุคคลที่จะดู",
		"statisticalField": "ชื่อช่องกรอกข้อมูลสถิติ",
		"searchField": "ข้อคำถามของช่องกรอกข้อมูล",
		"groupfieldName": "ชื่อช่องช่องกรอกข้อมูลแบบกลุ่ม",
		"format": "แบบฟอร์ม",
		"dynamicreportKeyName": "ชื่อช่องกรอกข้อมูลสถิติ",
		"sortKey": "จัดเรียงชื่อช่อง",
		"sortingWay": "จัดเรียงตาม",
		"permissionsSet": "การตั้งค่าการอนุญาต",
		"compositeKeys": "ช่องกรอกข้อมูลรวม",
		"selectKey": "การเลือกช่อง",
		"cancleDelete": "ยกเลิกการลบแล้ว",
		"searchTimeTips": "เงื่อนไขข้อคำถามแบบคงที่ต้องมีช่องกรอกเวลาและไม่สามารถลบค่าเริ่มต้น",
		"keywordsNotEmptTips": "ไม่สามารถลบช่องกรอกข้อมูลสถิติ",
		"keyWordWayNotEmptTips": "ต้องเลือกค่าเริ่มต้นสำหรับวิธีสรุปช่องกรอกข้อมูลสถิติ",
		"fixedSearchKey": "แก้ไขเงื่อนไขการสืบค้นแล้ว"
	},
	"bqReport": {
		"downloadReport": "ดาวน์โหลดรายงาน",
		"reportTemplate": "รายงานที่ต้องการดึงข้อมูล",
		"driverStatusReportByShipment": "รายงานรายละเอียดสถานะคนขับตามพัสดุ",
		"driverStatusReportByJob": "รายงานรายละเอียดสถานะคนขับตามงาน",
		"createDate": "วันที่สร้าง",
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/report/report.js